import { bool, shape } from "prop-types";

import LazyLoadImage from "web/Layout/Common/LazyLoadImage";

import Anchor from "web/Components/Common/Anchor";

import classify from "web/classify";

import styles from "./banner.scss";
import usePromotionAnalytics from "./usePromotionAnalytics";

const Banner = ({ banner, classes, mobile }) => {
  const { onPromoClick } = usePromotionAnalytics([banner], mobile);

  return banner?.img ? (
    <Anchor
      to={banner.url}
      title={banner.title}
      className={classes.banner}
      onClick={onPromoClick}
    >
      <LazyLoadImage
        alt={banner.alt}
        src={mobile ? banner.img_mobile : banner.img}
        className={classes.banner__image}
        isCampaign
        isAutoresized={false}
      />
    </Anchor>
  ) : null;
};

Banner.propTypes = {
  banner: shape({}),
  classes: shape({}).isRequired,
  mobile: bool,
};

Banner.defaultProps = {
  mobile: false,
  banner: {},
};

export default classify(styles)(Banner);
